import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";

export const Container = ({ children, className = "" }) => (
  <div className={`max-w-7xl mx-auto px-6 lg:px-12 ${className}`}>{children}</div>
);

export const Overline = ({ children, testid, light = false, className = "mb-6" }) => (
  <p
    data-testid={testid}
    className={`text-xs font-semibold tracking-[0.2em] uppercase ${light ? "text-[#8FA1B5]" : "text-[#5A6B7C]"} ${className}`}
  >
    {children}
  </p>
);

export const SectionTitle = ({ children, testid, className = "" }) => (
  <h2
    data-testid={testid}
    className={`font-heading text-3xl md:text-4xl font-semibold tracking-tight text-[#0B1B3D] ${className}`}
  >
    {children}
  </h2>
);

export const Tag = ({ children, light = false }) => (
  <span
    className={`inline-block border px-3 py-1.5 text-sm leading-none ${
      light ? "border-white/25 text-white/85" : "border-[#D5DBE3] text-[#2A2D34]"
    }`}
  >
    {children}
  </span>
);

export const Flow = ({ steps, light = false, testid }) => (
  <div data-testid={testid} className="flex flex-wrap items-center gap-x-3 gap-y-2">
    {steps.map((s, i) => (
      <span key={s} className="flex items-center gap-3">
        <span className={`font-heading text-sm font-bold tracking-[0.15em] uppercase ${light ? "text-white" : "text-[#0B1B3D]"}`}>
          {s}
        </span>
        {i < steps.length - 1 && (
          <ArrowRight size={14} weight="light" className={light ? "text-white/50" : "text-[#9AA5B1]"} />
        )}
      </span>
    ))}
  </div>
);

export const InternalLinks = ({ label, links, testid }) => (
  <div data-testid={testid} className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm">
    <span className="text-[#9AA5B1]">{label}</span>
    {links.map((l) => (
      <Link key={l.href} to={l.href} className="inline-flex items-center gap-1.5 text-[#0B1B3D] font-medium hover:text-[#5A6B7C] transition-colors">
        {l.label}
        <ArrowRight size={14} weight="light" />
      </Link>
    ))}
  </div>
);
